import { Box, Card, Grid } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

export default function AtendimentoCardSkeleton() {
  return (
    <Card
      variant="outlined"
      elevation={0}
      style={{
        width: '100%',
        padding: 16,
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={11}>
          <Box display="flex" flexDirection="column" gridGap={8}>
            <Skeleton width={120} height={20} />

            <Box display="flex" justifyContent="space-between">
              <Skeleton width={140} height={20} />
              <Skeleton width={90} height={20} />
            </Box>

            <Box display="flex" justifyContent="space-between">
              <Skeleton width={160} height={20} />
              <Skeleton width={120} height={20} />
            </Box>

            <Skeleton width={180} height={20} />

            <Skeleton variant="rect" width="100%" height={28} />
          </Box>
        </Grid>

        <Grid
          item
          xs={1}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          <Skeleton variant="circle" width={20} height={20} />
        </Grid>
      </Grid>
    </Card>
  );
}
